/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_3_DInputs */

const en_mk_tut_gl_3_d = /** @type {(inputs: Mk_Tut_Gl_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One accountable piece of work, with a status and a single assignee.`)
};

const id_mk_tut_gl_3_d = /** @type {(inputs: Mk_Tut_Gl_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pekerjaan yang bisa dipertanggungjawabkan, dengan status dan satu penanggung jawab.`)
};

/**
* | output |
* | --- |
* | "One accountable piece of work, with a status and a single assignee." |
*
* @param {Mk_Tut_Gl_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_3_d = /** @type {((inputs?: Mk_Tut_Gl_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_3_d(inputs)
	return en_mk_tut_gl_3_d(inputs)
});